<template>
  <div class="dynamicalDevOpsPage mainPageBg">
    <DevOpsPublicCom :system="'动力系统'" />
  </div>
</template>

<script>
import DevOpsPublicCom from "@/components/DevOps/DevOpsPublicCom.vue";
export default {
  components: {
    DevOpsPublicCom,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
